module.exports = __webpack_public_path__ + "static/media/ear.8fe08dff.svg";